<script setup lang="ts">
import { MMIcon, MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import { ButtonPrimaryAccented } from '~/features/ui-kit';
import { useSignIn } from '../business/useSignIn';
import IconUserBlocked from './IconUserBlocked.vue';

const { signInBlockedStep, closeSignInPopup, resetStep } = useSignIn();
</script>

<template>
  <MMPopupDefault class="popup" @close="resetStep">
    <div class="popup-content">
      <IconUserBlocked class="popup-content__icon" />
      <MMText class="auth-blocked__title" font="Title L/Semibold">Аккаунт заблокирован</MMText>
      <MMText class="auth-blocked__description" font="Body L/Regular">
        Продолжите без него или обратитесь в поддержку
      </MMText>
    </div>

    <template #footer>
      <ButtonPrimaryAccented class="auth-blocked__button" size="l48" w100 @click="$emit('close')">
        Продолжить без аккаунта
      </ButtonPrimaryAccented>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup
  width 480px

  +Media(Mobile)
    max-width calc(100vw - 32px)

  &-content
    text-align center
    padding 64px 0
    display flex
    flex-direction column
    gap 4px

    &__icon
      margin-bottom 24px
      display flex
      width 100%
      align-items center
      justify-content center
</style>